import { render, staticRenderFns } from "./matching-card-compact-list-header.vue?vue&type=template&id=0fe1163a&scoped=true&"
import script from "./matching-card-compact-list-header.vue?vue&type=script&lang=ts&"
export * from "./matching-card-compact-list-header.vue?vue&type=script&lang=ts&"
import style0 from "./matching-card-compact-list-header.vue?vue&type=style&index=0&id=0fe1163a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe1163a",
  null
  
)

export default component.exports